import { useSyncExternalStore } from "react";
import { PrivateAgentAgentIdSchema } from "@salesko/contracts";
import { readStoredSaleskoSession, SaleskoSessionChangeEvent } from "../../lib/api";

const selectionChanged = "salesko-private-agent-selection-change";
export const lastPrivateAgentKey = (tenantId: string) => `salesko.lastPrivateAgent:${tenantId}`;

function subscribe(listener: () => void) {
  window.addEventListener("storage", listener);
  window.addEventListener(SaleskoSessionChangeEvent, listener);
  window.addEventListener(selectionChanged, listener);
  return () => {
    window.removeEventListener("storage", listener);
    window.removeEventListener(SaleskoSessionChangeEvent, listener);
    window.removeEventListener(selectionChanged, listener);
  };
}

function snapshot(): string | undefined {
  const session = readStoredSaleskoSession();
  if (!session) return undefined;
  const value = window.localStorage.getItem(lastPrivateAgentKey(session.tenantId));
  return value === null ? undefined : PrivateAgentAgentIdSchema.parse(value);
}

export function rememberPrivateAgent(agentId: string | undefined) {
  const session = readStoredSaleskoSession();
  if (!session) throw new Error("An authenticated session is required to remember an Agent.");
  const key = lastPrivateAgentKey(session.tenantId);
  if (agentId) window.localStorage.setItem(key, PrivateAgentAgentIdSchema.parse(agentId));
  else window.localStorage.removeItem(key);
  window.dispatchEvent(new window.Event(selectionChanged));
}

/** A per-user browser preference; API Profile/Placement still authorize execution. */
export function useLastPrivateAgent() {
  const agentId = useSyncExternalStore(subscribe, snapshot, () => undefined);
  return [agentId, rememberPrivateAgent] as const;
}
